<template>
  <v-container fluid class="wrapper">
    <div class="conteudo">
      <div class="info">
        <InfoBlock
          class="info-block"
          :styleClass="styleClass"
          v-if="step == 1"
          :title="$t('Recuperar Senha')"
          :description="
            $t(
              'Insira o e-mail cadastrado na sua conta! Vamos te enviar um código para recuperação da sua senha.'
            )
          "
        />
        <InfoBlock
          class="info-block"
          :styleClass="styleClass"
          v-if="step == 2"
          :title="$t('Recuperar Senha')"
          :description="
            $t('Insira o código de recuperação que enviamos para o seu e-mail.')
          "
        />
        <InfoBlock
          class="info-block"
          :styleClass="styleClass"
          v-if="step == 3"
          :title="$t('Recuperar Senha')"
          :description="$t('Defina sua nova senha')"
        >
          <br />
          <br />
          Requisitos de senha:
          <br />
          Mínimo de 8 caracteres
          <br />
          Mínimo de uma letra maiúscula
          <br />
          Mínimo de um caractere especial
        </InfoBlock>

        <InfoBlock
          class="info-block"
          :styleClass="styleClass"
          v-if="step == 4"
          :title="$t('Recuperar Senha')"
          :description="$t('Senha nova ok')"
        />
      </div>

      <div style="flex: 2 1; z-index: 100">
        <div class="itens-stepper">
          <div v-show="step == 1">
            <TCard
              title="E-mail"
              :titlePage="$t('Recuperar senha')"
              :descriptionPage="
                $t(
                  'Insira o e-mail cadastrado na sua conta! Vamos te enviar um código para recuperação da sua senha.'
                )
              "
            >
              <v-form ref="form" lazy-validation @submit.prevent>
                <v-row class="flex-column" align="start">
                  <v-col>
                    <v-text-field
                      hide-details="auto"
                      v-model="user.Email"
                      :rules="emailRules"
                      color="primary"
                      required
                      label="E-mail"
                      @keyup.enter="sendEmail"
                    />
                  </v-col>
                </v-row>
              </v-form>

              <v-btn
                depressed
                :loading="loading"
                :disabled="!valid"
                class="primary-button mt-12"
                block
                @click="sendEmail"
              >
                {{ $t('Enviar para e-mail') }}
              </v-btn>
            </TCard>
          </div>

          <div v-show="step == 2">
            <TCard
              :title="$t('Código')"
              :titlePage="$t('Código')"
              :descriptionPage="
                $t(
                  'Insira o código de recuperação que enviamos para o seu e-mail.'
                )
              "
            >
              <v-form ref="secondForm" lazy-validation @submit.prevent>
                <v-row class="flex-column" align="start">
                  <v-col>
                    <v-text-field
                      hide-details="auto"
                      lazy-validation
                      v-model="user.pin"
                      :rules="[(v) => !!v || 'Pin requerido']"
                      color="primary"
                      required
                      label="XXXX"
                      @keyup.enter="validatePin"
                    />
                  </v-col>
                </v-row>
              </v-form>
              <v-btn
                depressed
                :loading="loading"
                :disabled="!valid"
                class="primary-button mt-12"
                block
                @click="validatePin"
              >
                {{ $t('Continuar') }}
              </v-btn>
              <div class="btn-forgot-password mt-8">
                <span @click="sendEmail">
                  {{ $t('Não recebi código') }}
                </span>
              </div>
            </TCard>
          </div>

          <div v-show="step == 3">
            <TCard
              :title="$t('Senha')"
              :titlePage="$t('Senha')"
              :descriptionPage="$t('Defina sua nova senha.')"
            >
              <v-form ref="thirdForm" lazy-validation @submit.prevent>
                <v-row class="flex-column senha ma-0" align="start">
                  <v-col>
                    <v-text-field
                      hide-details="auto"
                      v-model="user.Password"
                      placeholder="********"
                      :rules="[
                        (v) => !!v || 'Campo obrigatório',
                        (v) => /\d/.test(v) || 'Mínimo de um número',
                        minLength(user.Password),
                        specialCharacters(user.Password),
                        uppercaseLetter(user.Password),
                      ]"
                      color="primary"
                      required
                      :label="$t('Senha')"
                      :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="show ? 'text' : 'password'"
                      @click:append="show = !show"
                    />
                  </v-col>
                </v-row>

                <v-row class="flex-column senha ma-0" align="start">
                  <v-col>
                    <v-text-field
                      hide-details="auto"
                      v-model="ConfirmedPassword"
                      placeholder="********"
                      :rules="[
                        (v) => v == user.Password || 'Senhas não coincidem!',
                      ]"
                      color="primary"
                      required
                      :label="$t('Confirmar Senha')"
                      :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="show ? 'text' : 'password'"
                      @click:append="show = !show"
                    />
                  </v-col>
                </v-row>
              </v-form>

              <v-btn
                depressed
                :loading="loading"
                :disabled="!valid"
                class="primary-button mt-12"
                block
                @click="updatePassword"
              >
                {{ $t('Alterar Senha') }}
              </v-btn>
            </TCard>
          </div>

          <div v-if="step == 4" class="last-step">
            <TCard title="Completo!" titlePage="Completo!">
              <div class="success-message py-0">
                <span> {{ $t('Sua senha foi atualizada com sucesso!') }} </span>
              </div>
              <v-btn
                depressed
                :loading="loading"
                :disabled="!valid"
                class="primary-button mt-12"
                block
                @click="goLogin"
              >
                {{ $t('Logar') }}
              </v-btn>
            </TCard>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import ApiService from '../../../services/ApiService'
import InfoBlock from './components/infoBlock.vue'
import TCard from '../../../components/T/TCardAuth.vue'
export default {
  components: {
    InfoBlock,
    TCard,
  },
  data() {
    return {
      apiService: new ApiService(),
      styleClass: { color: '#fff' },
      show: false,
      loading: false,
      valid: true,
      step: 1,
      showMsg: false,
      ConfirmedPassword: '',
      user: {
        id: '',
        Email: '',
        Password: '',
        pin: '',
      },
      passwordRules: [(v) => !!v || 'Senha requerida'],
      emailRules: [
        (v) => !!v || 'E-mail requerido',
        (v) => /.+@.+\..+/.test(v) || 'E-mail inválido',
      ],
      equalPasswords: () => this.equalPasswordsMethod() || 'Senha não confere',
    }
  },
  methods: {
    specialCharacters(v) {
      if (v.length) {
        const specialCharacters = /[!@#$%^&*()_+[\]{};:'"<>,.?/~\\-]/

        if (specialCharacters.test(v) == false)
          return 'Mínimo de um caractere especial'

        return true
      }
      return true
    },

    uppercaseLetter(v) {
      if (v.length) {
        const uppercaseLetter = /[A-Z]/

        if (uppercaseLetter.test(v) == false)
          return 'Mínimo de uma letra maiúscula'

        return true
      }
      return true
    },

    minLength(v) {
      if (v.length) {
        if (v.length < 8) {
          return 'Mínimo de 8 caracteres'
        }
      }
      return true
    },

    sendEmail() {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.user.Email = this.user.Email.trim().toLowerCase()
        this.apiService
          .post('auth/forgot-password', this.user)
          .then((response) => {
            this.user.id = response.content.userId
            this.$toast.success('Foi enviado um código para o seu e-mail!')
            this.step = 2
            this.loading = false
          })
          .catch((err) => {
            this.$toast.success('Você receberá um e-mail caso exista.')
            this.step = 2
            this.loading = false
          })
      }
    },
    validatePin() {
      if (this.$refs.secondForm.validate()) {
        this.loading = true
        const data = { Code: parseInt(this.user.pin), UserId: this.user.id }
        this.apiService
          .post('auth/forgot-password/validate', data)
          .then(() => {
            this.loading = false
            this.step++
          })
          .catch(() => {
            this.$toast.error(this.$t('Erro ao validar pin'))
            this.loading = false
          })
      }
    },
    checkNewPassword() {
      if (this.user.Password == this.ConfirmedPassword) {
        this.showMsg = false
        return true
      } else {
        this.showMsg = true
        this.$toast.error('Senhas não conferem')
        return false
      }
    },
    updatePassword() {
      if (this.$refs.thirdForm.validate()) {
        if (this.checkNewPassword()) {
          this.loading = true

          const data = {
            UserId: this.user.id,
            NewPassword: this.user.Password,
            Code: parseInt(this.user.pin),
          }

          this.apiService
            .post('auth/forgot-password/reset', data)
            .then(() => {
              this.loading = false
              this.step++
            })
            .catch(() => {
              this.loading = false
            })
        }
      }
    },
    goLogin() {
      this.$router.push({ name: 'LoginClient' })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/sass/variables.scss';

.btn-forgot-password {
  text-align: center;
  span {
    text-decoration-line: underline;
    cursor: pointer;
    color: $blue-2;
    font-weight: 600;
  }
}

.wrapper {
  padding: 1.5rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  .conteudo {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    padding: 0.5rem;
    position: relative;

    .card-div {
      z-index: 100;
      .primary-button block {
        background: $blue-1 !important;
        width: 100%;
        margin: 1rem 0;
      }
      .btn-forgot-password {
        text-align: center;
        span {
          text-decoration-line: underline;
          cursor: pointer;
          color: $blue-2;
          font-weight: 600;
        }
      }
      .btn-problems {
        text-align: center;
        span {
          font-weight: 600;
          font-size: 14px;
          line-height: 19px;
          text-decoration-line: underline;
          cursor: pointer;
          color: $blue-2;
        }
      }

      .last-step {
        .success-message {
          padding: 5rem 0;
        }

        @media (max-width: $mobile-1) {
          .success-message {
            padding: 3rem 0;
          }
        }
      }
    }
  }
}
.info-block {
  background: none;
  color: white;
  z-index: 100;
}
.conteudo .info {
  flex: 1 1 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none !important;
}
.conteudo .card-div {
  flex: 2 1 500px;
  position: relative;
  z-index: 100;
}
.v-stepper {
  max-width: 50%;
  margin: 0 auto;
  transition: 0.2s ease-in-out;
}
.stepper-container {
  position: absolute;
  left: 0;
  right: 0;
  top: -35px;
}
.step-counter {
  position: relative;
}
.step-counter >>> .step-count {
  position: absolute;
  top: 0;
  width: 100%;
  right: 4px;
  text-align: center;
  color: #b1d23d;
}

.card-div >>> .v-card {
  height: 500px;
}
.card-div >>> .v-card .content-card {
  padding: 1.5rem;
  max-width: 80%;
  margin: 0 auto;
}
.card-div >>> .v-card .logo-card {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 2rem 0;
}
.card-div >>> .v-card .title-card {
  margin: 2rem 0;
}
.card-div >>> .v-card .title-card span {
  font-weight: bold;
  font-size: 1.8em;
}
.card-div >>> .v-card .btn-forgot-password {
  text-align: center;
  margin: 2rem 0;
}
.card-div >>> .v-card .btn-forgot-password span {
  text-decoration-line: underline;
  cursor: pointer;
  color: #0f3565;
}

.card-div >>> .v-card .primary-button block {
  background: #426483 !important;
  width: 100%;
  margin: 2rem 0;
}

.card-div >>> .v-card .btn-problems {
  text-align: center;
  margin: 2rem 0;
}
.card-div >>> .v-card .btn-problems span {
  text-decoration-line: underline;
  cursor: pointer;
  color: #0f3565;
}

@media screen and (max-width: 750px) {
  .v-stepper {
    max-width: 100%;
  }
  .info {
    display: none !important;
  }
}
</style>
